import React, { createContext, useContext, useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { stripePublishableKey, isStripeConfigured } from '../config/stripe';

const StripeContext = createContext();

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
};

// Load stripe instance
let stripePromise = null;
if (isStripeConfigured()) {
  stripePromise = loadStripe(stripePublishableKey);
}

export const StripeProvider = ({ children }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isStripeConfigured()) {
      setError('Stripe is not configured. Please add your Stripe publishable key.');
      setIsLoaded(true);
      return;
    }

    if (stripePromise) {
      stripePromise.then(() => {
        setIsLoaded(true);
        console.log('Stripe loaded successfully');
      }).catch((err) => {
        console.error('Failed to load Stripe:', err);
        setError('Failed to load payment system');
        setIsLoaded(true);
      });
    }
  }, []);

  const value = {
    isLoaded,
    error,
    isConfigured: isStripeConfigured(),
    stripePromise
  };

  return (
    <StripeContext.Provider value={value}>
      {children}
    </StripeContext.Provider>
  );
};